// Branded full-cover loading screen: static KANN. logo + one calm loading bar,
// a soft ambient glow and the on-brand dot grid background.
export const KannLoader = ({ theme = "light", label = "Handleiding laden…", fadeOut = false }) => {
  const dark = theme === "dark";
  return (
    <div
      data-testid="kann-loader"
      className={`absolute inset-0 z-[80] flex items-center justify-center transition-opacity duration-700 ${fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      style={{
        backgroundColor: dark ? "#141416" : "#f6f6f4",
        backgroundImage: `radial-gradient(${dark ? "rgba(255,255,255,0.045)" : "#e6e6e2"} 1px, transparent 1px)`,
        backgroundSize: "22px 22px",
      }}
    >
      <div className="kann-enter relative flex flex-col items-center">
        <div
          className="pointer-events-none absolute -inset-24 rounded-full"
          style={{ background: "radial-gradient(circle, rgba(219,150,13,0.07), transparent 70%)", filter: "blur(32px)" }}
        />
        <div className="relative logo-font text-6xl leading-none" style={{ color: dark ? "#ffffff" : "#232323" }}>
          KANN<span className="text-[#DB960D]">.</span>
        </div>
        <div className={`relative kann-loader-track mt-8 h-[3px] w-48 rounded-full ${dark ? "bg-white/10" : "bg-black/[0.06]"}`}>
          <div className="kann-loader-bar" />
        </div>
        <div className={`relative mt-5 text-[10px] tracking-[0.35em] uppercase font-mono ${dark ? "text-white/40" : "text-[#9A9A94]"}`}>{label}</div>
      </div>
    </div>
  );
};

export default KannLoader;
